import React, { useState } from "react";
import FQ from "./FQ";
import Topbar from "./common/Topbar";


export default function FAQ() {
    const [faqs, setFaqs] = useState([
        {
          question: "1. What is SCLIB?",
          answer:
            "SCLIB is a comprehensive CSS library designed to simplify and enhance web development. It provides a wide range of pre-designed CSS components, styles, and utilities that can be easily integrated into your projects, saving you time and effort.",
          open: true
        },
        {
          question: "2. How do I get started with SCLIB?",
          answer: "To get started with SCLIB, you need to include the CSS file in your HTML document. You can either download the library from our website or use a CDN to include it directly. Once the CSS file is included, you can start utilizing the various classes, styles, and components provided by the library.",
          open: false
        },
        {
          question:
            "3. Can I customize the styles provided by SCLIB?",
          answer: "Yes, you can customize the styles provided by SCLIB to match your project's specific requirements. The library is built to be modular and allows you to override or extend the default styles easily. We recommend referring to the documentation or support resources for guidance on how to customize the library's styles effectively.",
          open: false
        }
        ,
        {
          question:
            "4. Does SCLIB work with all modern browsers?",
          answer: "Yes, SCLIB is designed to be compatible with all modern browsers, including Chrome, Firefox, Safari, Edge, and more. However, please note that older versions of some browsers may have limited support for certain CSS features. We recommend testing your project across different browsers and versions to ensure full compatibility.",
          open: false
        }
        ,
        {
          question:
            "5. Is SCLIB responsive and mobile-friendly?",
          answer: "Absolutely! SCLIB is built with responsiveness and mobile-friendliness in mind. The library includes responsive grid systems, flexible components, and media query breakpoints to ensure your website or application looks great on various devices and screen sizes.",
          open: false
        }
        ,
        {
          question:
            "How many questions does it take to makes a succesful FAQ Page?",
          answer: "This many!",
          open: false
        }
        ,
        {
          question:
            "6. Can I use SCLIB with other CSS frameworks?",
          answer: "Yes, you can use SCLIB alongside other CSS frameworks or libraries. Our library is designed to be modular and can be easily integrated into existing projects without conflicts. However, we recommend carefully managing and organizing your CSS files to avoid any potential clashes between styles.",
          open: false
        }
        ,
        {
          question:
            "7. Is SCLIB compatible with CSS preprocessors like Sass or Less?",
          answer: "Yes, SCLIB is compatible with CSS preprocessors such as Sass or Less. You can import the library into your preprocessor workflow and take advantage of their features, such as variables, mixins, and functions, to customize the library's styles more efficiently.",
          open: false
        }
        ,
        {
          question:
            "8. How often is SCLIB updated?",
          answer: "We strive to provide regular updates and improvements to SCLIB. The frequency of updates may vary depending on the development cycle and user feedback. We recommend checking our website or subscribing to our newsletter to stay up to date with the latest releases, bug fixes, and new features.",
          open: false
        }
        ,
        {
          question:
            "9. I found a bug or have a suggestion for SCLIB. How can I report it?",
          answer: "We appreciate your feedback! If you encounter a bug or have a suggestion for improving SCLIB, please reach out to our support team through our contact page or support email. Provide as much detail as possible, including steps to reproduce the issue, browser and device information, and any relevant code samples.",
          open: false
        }
        ,
        {
          question:
            "10. Can I contribute to SCLIB?",
          answer: `Yes, we welcome contributions from the community! You can contribute to SCLIB by submitting bug reports, feature requests, or even pull requests on our GitHub repository. Please review our contribution guidelines and code of conduct before making any contributions.
          We hope this FAQ has addressed some of your questions about SCLIB. If you have any further inquiries or need assistance, don't hesitate to reach out to our dedicated support team. Happy coding with SCLIB!`,
          open: false
        }
      ]);
    
      const toggleFAQ = index => {
        setFaqs(
          faqs.map((faq, i) => {
            if (i === index) {
              faq.open = !faq.open;
            } else {
              faq.open = false;
            }
    
            return faq;
          })
        );
      };
    
      return (
        <>
        <Topbar option={"faq"}/>
        <div className="bod">
          <div className="faqs">
          <h2>Frequently asked questions</h2>
          <p>Welcome to the FAQ page for SCLIB. Here, we have compiled a list of commonly asked questions and their answers to help you better understand and utilize our CSS library effectively. If you have a question that is not covered here, please feel free to reach out to our support team for assistance.</p>
            {faqs.map((faq, index) => (
              <FQ faq={faq} index={index} key={index} toggleFAQ={toggleFAQ} />
            ))}
          </div>
        </div>
        </>
        
      );
}
